/* import external modules */
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '550px',
    padding: '40px 24px',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  title: {
    padding: '0px 0 0 0',
    fontSize: '1.3rem',
    color: '#320066',
    fontWeight: 'bold',
    position: 'absolute',
    top: '20px',
  },
  content: {
    padding: '24px 0',
    color: '#4F5356',
    overflowY: 'initial',
    '& > form': {
      gap: '1rem',
      display: 'grid',
    },
  },
  actions: {
    padding: '10px 0 0 0',
    justifyContent: 'center',
  },
  buttomClose: {
    color: '#006CA5',
    textTransform: 'inherit',
    position: 'absolute',
    border: 'none',
    top: '10px',
    right: '8px',
    boxShadow: 'none',
    background: '#FFFFFF',
    '&:hover': {
      background: '#FFFFFF',
    },
  },
  buttom: {
    width: 'auto',
    color: '#320066',
    textTransform: 'inherit',
    border: 'none',
    boxShadow: 'none',
    background: '#FFFFFF',
    '&:hover': {
      background: '#FFFFFF',
      textDecoration: 'underline',
    },
  },
  buttons: {
    justifyContent: 'space-around',
    padding: '0',
  },
}));

export default useStyles;
